<template>
	<div class="d-flex flex-column h-100">
		<header class="masthead mb-auto">
			<nav class="navbar navbar-expand-lg navbar-dark bg-no-trans">
				<div class="container">
					<a class="navbar-brand" href="/#/">
						<img src="../../assets/img/logo.png" alt="Logo" />
					</a>

					<div class="my-2 my-lg-0">
						<button
							class="btn btn-light btn-sm my-2 my-sm-0"
							@click="gotoSingin"
						>
							Login
						</button>
					</div>
				</div>
			</nav>
		</header>

		<section
			class="login-container height-auto py-5 bg-grey200 flex-shrink-0 container-fluid"
		>
			<form class="form-signin card mt-4 bg-light">
				<h5 class="text-center mb-3">Reset Password Phone</h5>
				<div class="form-group text-center ">
					<img src="../../assets/img/sent.svg" width="40" alt="" />
				</div>
				<div class="form-group">
					<p class="text-green text-center">
						Enter the verification code sent to <br />{{ regNum }} to continue
					</p>
				</div>
				<div class="form-group">
					<div class="input-group verify">
						<input
							class="form-control"
							v-on:keyup="$event.target.nextElementSibling.focus()"
							maxlength="1"
							v-model="dataCode.one"
						/>
						<input
							class="form-control"
							v-on:keyup="$event.target.nextElementSibling.focus()"
							maxlength="1"
							v-model="dataCode.two"
						/>
						<input
							class="form-control"
							v-on:keyup="$event.target.nextElementSibling.focus()"
							maxlength="1"
							v-model="dataCode.three"
						/>
						<input
							class="form-control"
							v-on:keyup="$event.target.nextElementSibling.focus()"
							maxlength="1"
							v-model="dataCode.four"
						/>
						<input
							class="form-control"
							v-on:keyup="$event.target.nextElementSibling.focus()"
							maxlength="1"
							v-model="dataCode.five"
						/>
						<input class="form-control" maxlength="1" v-model="dataCode.six" />
					</div>
				</div>

				<button
					class="btn btn-primary btn-block text-uppercase mt-3"
					v-on:click.stop.prevent="verifyPhone"
				>
					Reset Password
				</button>
				<small class="text-center pt-3" v-if="showupdatepasswordErr">{{
					textfloating
				}}</small>
			</form>
			<p class="text-center pt-4">Download App</p>
			<p class="text-center ">
				<img
					src="../../assets/img/google-play.png"
					alt=""
					class="cursor-pointer"
					@click="gotoAppStore('google')"
				/>
				<img
					src="../../assets/img/app-store.png"
					class="ml-2 cursor-pointer"
					alt=""
					@click="gotoAppStore('apple')"
				/>
			</p>
		</section>

		<!-- Footer -->
		<footer class="footer text-dark mt-auto py-3 bg-grey200">
			<!-- Footer Links -->
			<div class="container text-center">
				<a href="/#/">Home</a>
				<a href="/#/cookiesprivacy">Privacy Policy</a>
				<a href="/#/terms">Terms of Use</a>
				<a href="/#/faqs">FAQ</a>
			</div>
			<!-- Footer Links -->

			<!-- Copyright -->
			<div class="footer-copyright text-center py-2">
				Copyright © 2021. All Rights Reserved by IBAKA Entertainment Inc.
			</div>
			<!-- Copyright -->
		</footer>
		<!-- Footer -->
	</div>
</template>

<style scoped>
.cursor-pointer {
	cursor: pointer;
}

.py-5{
  padding-top: 18rem !important;
  padding-bottom: 8rem !important;
 min-height: 100vh !important;
}


</style>

<script>
export default {
	name: "getCodeResetPhone",
	components: {},
	created() {
		   this.$store.commit("showPopup", false);
		this.$store.commit("showdefaultFooter", false);
		this.$store.commit("showdefaultnav", false);
		this.regNum = this.$store.state.reset.telephone;

		// this.verifyEmail();
	},
	methods: {
		gotoAppStore(type) {
			if (type == "google") {
				window.open(
					"https://play.google.com/store/apps/details?id=com.ibakatv.mobile",
					"_blank"
				);
			} else if (type == "apple") {
				window.open(
					"https://apps.apple.com/gm/app/ibakatv/id1060646446",
					"_blank"
				);
			}
		},
		goToPackage() {
			this.$router.push("/packages");
		},
		gotoSingin() {
			this.$router.push("/login");
		},
		verifyPhone() {
			var self = this;
			var verificationCode =
				this.dataCode.one +
				this.dataCode.two +
				this.dataCode.three +
				this.dataCode.four +
				this.dataCode.five +
				this.dataCode.six;
			this.$store.commit("setLoader", true);
			this.$store.commit("updateResetField", {
				type: "code",
				value: verificationCode,
			});
			this.$store
				.dispatch("resetpasswordPhone")
				.then((res) => {
					this.showupdatepasswordErr = true;
					this.textfloating = res.message;
					this.$store.commit("setNotification", res.message);
					this.$store.commit("setLoader", false);
					setTimeout(function() {
						self.$store.dispatch("logout").then((res) => {
							if (res == "true") {
								self.$router.push("/login");
							}
						});
					}, 5000);
				})
				.catch((err) => {
					this.$store.commit("setLoader", false);
					this.showupdatepasswordErr = true;
					this.textfloating = err.response.data.error.message;
				});
		},
	},

	data() {
		return {
			regNum: "",
			dataCode: {
				one: "",
				two: "",
				three: "",
				four: "",
				five: "",
				six: "",
			},
			showupdatepasswordErr: false,
			token: "",
			email: "",
			phone: "",
			textfloating: "",
			successMsg: false,
			bgImg: "https://www.ibakatv.com/_nuxt/img/62cf189.jpg",
		};
	},
};
</script>
